import React, { useEffect, useRef } from 'react';

import SessionList from './SessionList';

import type { SessionDayGroup } from '../../TimelineSection.helpers';

const SessionListContainer = ({
  selectedSessionId,
  sessionsCount,
  sessionGroups,
  onSessionSelect,
}: {
  selectedSessionId: string | null;
  sessionsCount: number;
  sessionGroups: SessionDayGroup[];
  onSessionSelect: (sessionId: string) => void;
}) => {
  const listRef = useRef<HTMLDivElement | null>(null);

  // Keeps the selected row visible inside the list only (never scrolls the page).
  useEffect(() => {
    const list = listRef.current;
    const selectedRow = list?.querySelector<HTMLElement>(
      '[aria-current="true"]',
    );

    if (!list || !selectedRow) {
      return;
    }

    // `.list` is the offset parent of its rows (position: relative).
    const rowTop = selectedRow.offsetTop;
    const rowBottom = rowTop + selectedRow.offsetHeight;

    if (rowTop < list.scrollTop) {
      list.scrollTop = rowTop;
    } else if (rowBottom > list.scrollTop + list.clientHeight) {
      list.scrollTop = rowBottom - list.clientHeight;
    }
  }, [selectedSessionId]);

  return (
    <SessionList
      listRef={listRef}
      selectedSessionId={selectedSessionId}
      sessionsCount={sessionsCount}
      sessionGroups={sessionGroups}
      onSessionSelect={onSessionSelect}
    />
  );
};

export default React.memo(SessionListContainer) as any;
